import { render, staticRenderFns } from "./ExpenseTypeForm.vue?vue&type=template&id=dc3295d0&"
import script from "./ExpenseTypeForm.vue?vue&type=script&lang=js&"
export * from "./ExpenseTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports